import { gql } from '@apollo/client';
import { SearchFilter } from 'types/Filters';

const listOrganizationEnvironments = (
    organizationUri: string,
    filter: SearchFilter,
) => {
    return {
        variables: {
            organizationUri,
            filter,
        },
        query: gql`
            query getOrg($organizationUri: String, $filter: EnvironmentFilter) {
                getOrganization(organizationUri: $organizationUri) {
                    environments(filter: $filter) {
                        count
                        page
                        pageSize
                        hasNext
                        pages
                        hasPrevious
                        nodes {
                            label
                            AwsAccountId
                            SamlGroupName
                            created
                            environmentUri
                            owner
                            AwsProdAccountId
                            AwsDevAccountId
                            AwsTestAccountId
                            AwsToolAccountId
                            AwsValAccountId
                        }
                    }
                }
            }
        `,
    };
};

export default listOrganizationEnvironments;
